module.exports = __webpack_public_path__ + "29dc60a4cc71fe97ecc44974431b47fa.pdf";